import React, { Component } from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"
import ko from "date-fns/locale/ko";

class DataPicker1 extends Component {
    componentDidUpdate(prevState) {
        if (this.props.day !== prevState.day) {
            this.setState({day: this.props.day})
        }
    }

    constructor(props) {
        super()
        let day = props.day

        this.state = {day: day}
    }

    render() {

        const changeValue = (date) => {
            if (this.props.id === "startDate" || this.props.id === "endDate") {
                const startDateInput = document.getElementById("startDate");
                const endDateInput = document.getElementById("endDate");

                const startDateValue = startDateInput ? new Date(startDateInput.value) : null;
                const endDateValue = endDateInput ? new Date(endDateInput.value) : null;

                if (this.props.id === "startDate" && endDateValue && date > endDateValue) {
                    alert("시작일은 종료일보다 늦을 수 없습니다.");
                    return;
                }

                if (this.props.id === "endDate" && startDateValue && date < startDateValue) {
                    alert("종료일은 시작일보다 빠를 수 없습니다.");
                    return;
                }
            }

            this.setState({ day: date });
        };


        return(
            <ReactDatePicker
                closeOnScroll={true}
                selected={this.state.day}
                onChange={(date) => changeValue(date)}
                locale={ko}
                dateFormat="yyyy-MM-dd"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                id={this.props.id}
                className='dayBox dataPicker'
            />
        )
    }
}
export { DataPicker1 };